import React, { useRef } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddEnterpriseGroupForm from './AddEnterpriseGroupForm';

const AddEnterpriseGroupModal = ({ isOpen, onConfirm, onCancel }) => {
  const formRef = useRef(null);

  const handleSubmit = () => {
    console.log('formRef.current',formRef.current);
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Add Enterprise Group</ModalHeader>
      <ModalBody>
        <AddEnterpriseGroupForm ref={formRef} onFormSubmit={onConfirm} />
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEnterpriseGroupModal;
